import { Behavior } from '../Behavior';
export class Decorator extends Behavior {
    invalidate() {
        super.invalidate();
        this.child?.invalidate();
    }
}
//# sourceMappingURL=Decorator.js.map